import React from 'react';
import  Logo from '../../assets/images/new-images/logoNew.png';
import { getUserDetails,initialNameHandle } from '../../Helpers/Chat/User';
import { deleteItemFromLocalStorage, encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from '../../Helpers/Chat/webChatEncryptDecrypt';
import ProfileImage from '../Common/ProfileImage';
import CallControlButtons from './CallControlButtons';
import SDK from '../../SDK';
import { store } from '../../Redux/store';
import { BackToChatHoc } from '../../assets/images';
import { addShowConfrenceData } from '../../Redux/feature/showConfrenceDataSlice';
import { getGroupData } from '../../Helpers/Chat/Group';
import { resetCallData } from '../../callback';
import { CALL_SESSION_STATUS_CLOSED } from '../../Helpers/Call/Constant';
import { useSelector } from 'react-redux';
import callLogs from './CallLogs/callLog';

let timer;

const Connecting = (props) => {
    const { endCallAction = ()=> {} } = props
    const callConnectionDataEndCall = useSelector(state => state.callConnectionDate)
    // const { showConfrenceData } = useSelector(state => state.showConfrenceData)
    const addCustomCall = useSelector(state => state.addCustomCall.data)
    const { 
        hideCallScreen 
     } = props

    React.useEffect(()=>{
        startTimer();
        return () => (clearTimeout(timer));
    })

    const startTimer = () => {
        timer = setTimeout(() => {
            endCall()
        }, 30000);
    }

    const endCall = async () => {
        SDK.endCall();
        resetCallData();
        endCallAction();
        callLogs.update(callConnectionDataEndCall?.data.roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": CALL_SESSION_STATUS_CLOSED
        });
        encryptAndStoreInLocalStorage('callingComponent',false)
        deleteItemFromLocalStorage('roomName')
        deleteItemFromLocalStorage('callType')
        deleteItemFromLocalStorage('call_connection_status')
        store.dispatch(addShowConfrenceData({
            showComponent: false,
            showCalleComponent:false
        }))
    }
    
    const  getGroupDetails = (groupId)=>{
        let rosterDataGD = {};
        let group = getGroupData(groupId);
        rosterDataGD.displayName = group.groupName;
        rosterDataGD.image = group.groupImage;
        rosterDataGD.thumbImage = group.thumbImage
        rosterDataGD.jid = group.groupId;
        rosterDataGD.chatType = "groupchat";
        return rosterDataGD;
    }
    const  callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'))
    const containerStyle = {
        width: '100%',
        height: '100%',
    };

    let rosterData = {};
        
    if(callConnectionData){
        let user = "";
        if(callConnectionData.callMode === "onetoone"){
            user = callConnectionData.to;
            rosterData = getUserDetails(user);
        } else if(callConnectionData.callMode === "onetomany"){
            if(callConnectionData.groupId !== "" && callConnectionData.groupId !== null && callConnectionData.groupId !== undefined){
                user = callConnectionData.groupId.includes("@") ? callConnectionData.groupId.split('@')[0] : callConnectionData.groupId                
                rosterData = getGroupDetails(user);
            } else {
                user = callConnectionData.from;
                rosterData = getUserDetails(user);
            }
        }            
    }

    const handleHideCallScreen = e => {
        e.stopPropagation();
        hideCallScreen();
    }

    let chatType = rosterData.chatType;        
    let toUser = "";
    if(callConnectionData.from && callConnectionData.to){
        if(callConnectionData.to){
            toUser = callConnectionData.to.includes('@') ? callConnectionData.to.split('@')[0] : callConnectionData.to
        } else {
            toUser = callConnectionData.from.includes('@') ? callConnectionData.from.split('@')[0] : callConnectionData.from
        }
    }

    let initialName = initialNameHandle(rosterData, rosterData.initialName);

    return (
        <div  className="calling-Popup webcall-calling" style={containerStyle}>
            {!addCustomCall && <div className="optionButton visible">
                <span title="Back to chat" className="BackToChat" onClick={()=>handleHideCallScreen() } >
                    <i className="backIcon"><span className="toggleAnimation"></span>
                        <BackToChatHoc/>
                    </i>
                </span>
            </div>}
        
            <div className="callDetails">
                <div className="logosm" style={{ display: "none" }}><img src={Logo} alt="Logo"/></div>
                <span className="callingStatus Connecting"><span>{"Connecting "}
                    <div className="callingAnimation connect"><span className="dot"></span><span className="dot"></span><span className="dot"></span></div></span>
                </span>
                    <span className="callerName">{rosterData.displayName ? rosterData.displayName: toUser }</span>
            </div>
            <div className="avatar" id="dominantSpeakerAvatar">
                <ProfileImage
                    name = {initialName}
                    chatType={chatType}
                    temporary={false}
                    imageToken={rosterData.thumbImage !== "" ? rosterData.thumbImage : rosterData.image}
                />
            </div>      
            <CallControlButtons 
                handleEndCall={endCall}
                videoMute={false} 
                audioMute={false}
                audioControl={false}
                videoControl={false}
            />
        </div>
        );
    }

export default Connecting;


